import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { OnlinePaymentReceipt } from "../state/helpers/OnlinePaymentReceipt"

type OwnProps = {
    pay: OnlinePaymentReceipt,
}

const BankAccountDetails = (props: OwnProps) => {
    const { pay } = props

    if (!pay.bankDetails) {
        return <></>
    }

    return (
        <div className="px-3" style={{ width: "23%" }}>
            <p className="mb-1 border-bottom">
                <small>
                    <FormattedMessage
                        id="payment.payment_method"
                        defaultMessage="Payment method"
                    />
                </small>
            </p>
            <pre className="mb-0">
                {pay.bankDetails.attributes.bankName.toUpperCase()}
            </pre>
            <pre className="mb-0">
                {pay.bankDetails.attributes.accountHolderName}
            </pre>
            <pre className="mb-0">
                {`******** ${pay.bankDetails.attributes.last4}`}
            </pre>
        </div>
    )
}

export default injectIntl(BankAccountDetails)


// WEBPACK FOOTER //
// ./src/payment/bankaccountdetails.component.tsx